module.exports = __webpack_public_path__ + "img/Charles Yates at Graduation, 1958  (1).02acdcd7.jpg";